/**
 * 地址管理
 */
import CommonApi from 'api/common.js';
var api = {
  postAddressList: function postAddressList(params) {
    return CommonApi.post('/dayaotex-server-users/postAddress/postAddressList', params);
  },
  selectPostAddress: function selectPostAddress(params) {
    return CommonApi.post('/dayaotex-server-users/postAddress/selectPostAddress', params);
  },
  addPostAddress: function addPostAddress(params) {
    return CommonApi.post('/dayaotex-server-users/postAddress/addPostAddress', params);
  },
  updatePostAddress: function updatePostAddress(params) {
    return CommonApi.post('/dayaotex-server-users/postAddress/updatePostAddress', params);
  },
  delPostAddress: function delPostAddress(params) {
    return CommonApi.post('/dayaotex-server-users/postAddress/delPostAddress', params);
  }
};
export default api;